/**
 * Centralized config for environment variables.
 * Never commit secrets; use `.env` (gitignored) and `.env.example` for documentation.
 * Create React App only exposes variables prefixed with `REACT_APP_` to the client bundle.
 */
/**
 * API base for browser + mobile (site-android).
 * Production default: same-origin /api (the box nginx proxies /api to mgv-api on :3000).
 * Dev default: /api (setupProxy forwards to REACT_APP_BACKEND_UPSTREAM).
 * Override REACT_APP_API_URL to point the browser at a different API origin.
 */
function resolveApiUrl() {
  const explicit = String(process.env.REACT_APP_API_URL || '').trim();
  if (explicit) {
    return explicit.replace(/:443(?=\/|$)/, '');
  }
  return '/api';
}

export const API_URL = resolveApiUrl()
/** Admin email for notifications. Must be set in .env for form submissions to work. */
export const ADMIN_EMAIL = process.env.REACT_APP_ADMIN_EMAIL || ''

/**
 * Album folder structure (dropdown + chips): load from backend GET …/photo-album/folder-index (Mongo + S3 sync).
 * Set to '0' only for offline/dev without API — then optional static JSON fallback applies if enabled below.
 */
export const PHOTO_FOLDER_FROM_BACKEND =
  process.env.REACT_APP_PHOTO_FOLDER_FROM_BACKEND !== '0'

/** When true with backend disabled: merge public/data/photo-album-folder-index.json + bundled defaults (legacy). */
export const PHOTO_FOLDER_STATIC_FALLBACK =
  process.env.REACT_APP_PHOTO_FOLDER_STATIC_FALLBACK === '1'

// (none)

/** Cloudflare Turnstile site key. Empty => captcha disabled (frontend sends no token). */
export const TURNSTILE_SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY || ''
